export const rankFilterMessages = {
  'zh-CN': {
    firstOnly: '{job}（仅一转）', advancement: '{job}（{stage}转）', allAdvancements: '{job}（全部转职）',
    selectCategory: '全选{job}', unsupported: '暂不可选', cancel: '取消',
    level: '角色等级', anyLevel: '不限等级', levelStepHint: '每 5 级为一档',
    enterLevel: '输入角色等级', levelPlaceholder: '例如 73', levelHelp: '支持 1–200 级，榜单按每 5 级统计。',
    levelPreview: '查看 {range}角色的数据', invalidLevel: '请输入 1–200 之间的整数。',
    chooseLevel: '选择等级', chooseRange: '选择 {range}', browseLevels: '选择等级段',
    chooseJob: '选择职业', searchJob: '搜索职业名称', jobPlaceholder: '例如 龙骑士', clearJobSearch: '清空职业搜索',
    noJobs: '没有找到这个职业，试试其他名称，或选择全部职业。', jobsUnavailable: '暂时无法读取职业列表，可先选择全部职业。',
    selected: '已选条件', clearAll: '全部清除', clearConditions: '清空条件', apply: '应用筛选',
    applyHelp: '选好后点击「应用筛选」，关闭则保留原有条件。', back: '返回筛选条件',
  },
  'zh-TW': {
    firstOnly: '{job}（僅一轉）', advancement: '{job}（{stage}轉）', allAdvancements: '{job}（全部轉職）',
    selectCategory: '全選{job}', unsupported: '暫不可選', cancel: '取消',
    level: '角色等級', anyLevel: '不限等級', levelStepHint: '每 5 級為一個區間',
    enterLevel: '輸入角色等級', levelPlaceholder: '例如 73', levelHelp: '支援 1–200 級，排行榜每 5 級統計一次。',
    levelPreview: '查看 {range}角色的資料', invalidLevel: '請輸入 1–200 之間的整數。',
    chooseLevel: '選擇等級', chooseRange: '選擇 {range}', browseLevels: '選擇等級區間',
    chooseJob: '選擇職業', searchJob: '搜尋職業名稱', jobPlaceholder: '例如 龍騎士', clearJobSearch: '清除職業搜尋',
    noJobs: '找不到這個職業，請試試其他名稱，或選擇全部職業。', jobsUnavailable: '暫時無法讀取職業清單，可先選擇全部職業。',
    selected: '已選條件', clearAll: '全部清除', clearConditions: '清除條件', apply: '套用篩選',
    applyHelp: '選好後點選「套用篩選」，關閉則保留原有條件。', back: '返回篩選條件',
  },
  en: {
    firstOnly: '{job} (first advancement only)', advancement: '{job} (advancement {stage})', allAdvancements: '{job} (all advancements)',
    selectCategory: 'Select all {job}', unsupported: 'Unavailable', cancel: 'Cancel',
    level: 'Character level', anyLevel: 'Any level', levelStepHint: 'Grouped in five-level ranges',
    enterLevel: 'Enter character level', levelPlaceholder: 'e.g. 73', levelHelp: 'Enter a level from 1–200. Rankings use five-level ranges.',
    levelPreview: 'View records for characters at {range}', invalidLevel: 'Enter a whole number from 1–200.',
    chooseLevel: 'Choose level', chooseRange: 'Choose {range}', browseLevels: 'Choose a level range',
    chooseJob: 'Choose job', searchJob: 'Search job names', jobPlaceholder: 'Enter a job name', clearJobSearch: 'Clear job search',
    noJobs: 'No matching jobs. Try another name or choose all jobs.', jobsUnavailable: 'Job list unavailable. You can still choose all jobs.',
    selected: 'Selected filters', clearAll: 'Clear all', clearConditions: 'Clear filters', apply: 'Apply filters',
    applyHelp: 'Apply when ready. Closing keeps your previous filters.', back: 'Back to filters',
  },
  ja: {
    firstOnly: '{job}（1次のみ）', advancement: '{job}（{stage}次）', allAdvancements: '{job}（全転職）',
    selectCategory: '{job}をすべて選択', unsupported: '選択不可', cancel: 'キャンセル',
    level: 'キャラクターレベル', anyLevel: 'レベル指定なし', levelStepHint: '5レベルごとの範囲',
    enterLevel: 'キャラクターレベルを入力', levelPlaceholder: '例：73', levelHelp: '1～200 を入力。ランキングは5レベルごとに集計します。',
    levelPreview: '{range} のキャラクターの記録を表示', invalidLevel: '1～200 の整数を入力してください。',
    chooseLevel: 'レベルを選択', chooseRange: '{range} を選択', browseLevels: 'レベル帯を選択',
    chooseJob: '職業を選択', searchJob: '職業名を検索', jobPlaceholder: '職業名を入力', clearJobSearch: '職業検索をクリア',
    noJobs: '該当する職業がありません。別の名前で検索するか、すべての職業を選択してください。', jobsUnavailable: '職業一覧を読み込めません。すべての職業は選択できます。',
    selected: '選択中の条件', clearAll: 'すべてクリア', clearConditions: '条件をクリア', apply: '絞り込みを適用',
    applyHelp: '選択後に適用してください。閉じると元の条件を維持します。', back: '絞り込み条件に戻る',
  },
  ko: {
    firstOnly: '{job} (1차만)', advancement: '{job} ({stage}차)', allAdvancements: '{job} (모든 전직)',
    selectCategory: '{job} 전체 선택', unsupported: '선택 불가', cancel: '취소',
    level: '캐릭터 레벨', anyLevel: '레벨 제한 없음', levelStepHint: '5레벨 단위로 구분',
    enterLevel: '캐릭터 레벨 입력', levelPlaceholder: '예: 73', levelHelp: '1~200을 입력하세요. 순위는 5레벨 단위로 집계합니다.',
    levelPreview: '{range} 캐릭터의 기록 보기', invalidLevel: '1~200 사이의 정수를 입력하세요.',
    chooseLevel: '레벨 선택', chooseRange: '{range} 선택', browseLevels: '레벨 구간 선택',
    chooseJob: '직업 선택', searchJob: '직업 이름 검색', jobPlaceholder: '직업 이름 입력', clearJobSearch: '직업 검색 지우기',
    noJobs: '일치하는 직업이 없습니다. 다른 이름을 검색하거나 전체 직업을 선택하세요.', jobsUnavailable: '직업 목록을 불러올 수 없습니다. 전체 직업은 선택할 수 있습니다.',
    selected: '선택한 조건', clearAll: '모두 지우기', clearConditions: '조건 지우기', apply: '필터 적용',
    applyHelp: '선택 후 필터를 적용하세요. 닫으면 이전 조건이 유지됩니다.', back: '필터 조건으로 돌아가기',
  },
} as const
